import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { handleNumberInput } from "../../utils/commonUtils";

const DynamicFields = ({
  field,
  isUseFor,
  handleChangeItem,
  itemValues,
  itemTouched,
  itemErrors,
}: any) => {
  // useEffect(() => {
  //   console.log('@@itemValues',itemValues);
  // }, [itemValues]);
  const value = itemValues?.[field.name] 
  ?? itemValues?.customFieldDefaultValues?.[field.name] 
  ?? itemValues?.customFieldInitValues?.[field.name] 
  ?? "";

  switch (field.type) {
    case "Numeric TextBox":
    case "Decimal TextBox":
      return (
        <Form.Group className="form-field" controlId={field.name}>
          <Form.Label>{field.label}</Form.Label>
          <Form.Control
            type="number"
            placeholder={`Enter ${field.name}`}
            name={field.name}
            onChange={(e) => handleChangeItem(field.name)(e.target.value ?? "")}
            value={value}
            disabled={isUseFor === "View"}
            onInput={(e)=>handleNumberInput(e)}
            isInvalid={itemTouched?.[field.name] && !!itemErrors?.[field.name]}
          />
          <Form.Control.Feedback type="invalid">
            {itemErrors?.[field.name]}
          </Form.Control.Feedback>
        </Form.Group>
      );
    case "Textbox":
        return (
          <Form.Group className="form-field" controlId={field.name}>
            <Form.Label>{field.label}</Form.Label>
            <Form.Control
              type="text"
              placeholder={`Enter ${field.name}`}
              name={field.name}
              onChange={(e) => handleChangeItem(field.name)(e.target.value)}
              value={value}
              disabled={isUseFor === "View"}
              isInvalid={itemTouched?.[field.name] && !!itemErrors?.[field.name]}
            />
            <Form.Control.Feedback type="invalid">
              {itemErrors?.[field.name]}
            </Form.Control.Feedback>
          </Form.Group>
        );
    case "Dropdown":
        return (
            <Form.Group className="form-field" controlId={field.name}>
              <Form.Label>{field.label}</Form.Label>
              <Form.Select
                name={field.name}
                value={value}
                onChange={(e) => handleChangeItem(field.name)(e.target.value)}
                disabled={isUseFor === "View"}
                isInvalid={itemTouched?.[field.name] && !!itemErrors?.[field.name]}
              >
                <option value="">Select...</option>
                {field.options.map((option: any) => (
                  <option key={option.code} value={option.code}>
                    {option.text}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {itemErrors?.[field.name]}
              </Form.Control.Feedback>
            </Form.Group>
        );
    case "Checkbox":
      return (
            <Form.Group className="form-field" controlId={field.name}>
              <Form.Check
                type="checkbox"
                label={field.label}
                name={field.name}
                checked={!!value}
                onChange={(e) => handleChangeItem(field.name)(e.target.checked)}
                disabled={isUseFor === "View"}
                isInvalid={itemTouched?.[field.name] && !!itemErrors?.[field.name]}
              />
              <Form.Control.Feedback type="invalid" as="div">
                {itemErrors?.[field.name]}
              </Form.Control.Feedback>
            </Form.Group>
      );
    case "Radio Button":
      return (
        <Form.Group className="form-field" controlId={field.name}>
          <Form.Label>{field.label}</Form.Label>
          {field.options.map((option: any) => (
            <Form.Check
              inline
              key={option.code}
              type="radio"
              label={option.text}
              name={field.name}
              value={option.code}
              checked={value === option.code}
              onChange={(e) => handleChangeItem(field.name)(e.target.value)}
              disabled={isUseFor === "View"}
              isInvalid={itemTouched?.[field.name] && !!itemErrors?.[field.name]}
            />
          ))}
          {itemTouched?.[field.name] && itemErrors?.[field.name] && (
            <Form.Control.Feedback type="invalid" as="div">
              {itemErrors?.[field.name]}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      );

    default:
      return null;
  }
};

export default DynamicFields;
